<template>
  <div class="header-wrapper">
    <!-- 原 el-header 保持不变 -->
    <el-header class="navbar">

      <div class="logo" >
        <router-link to="/index" class="a-style"><img src="/static/logo.png" style="width:90px;height:20px;" /></router-link>
      </div>

      <div class="nav-links">
        <el-menu
            style="width:70%;"
            mode="horizontal"
            background-color="transparent"
            text-color="#fff"
            active-text-color="#409EFF"
            class="no-bottom-line"
        >
          <el-menu-item style="width:25%;text-align: center;font-size:18px;font-weight: bold">
            <router-link to="/index" class="a-style">{{ t('home') }}</router-link>
          </el-menu-item>
          <el-menu-item style="width:25%;text-align: center;font-size:18px;font-weight: bold">
            <router-link to="/productSearch" class="a-style">{{ t('product') }}</router-link>
          </el-menu-item>
          <el-menu-item style="width:25%;text-align: center;font-size:18px;font-weight: bold">
            <router-link to="/ContactUs" class="a-style">{{ t('support') }}</router-link>
          </el-menu-item>
          <el-menu-item style="width:25%;text-align: center;font-size:18px;font-weight: bold">
            <router-link to="/join" class="a-style">{{ t('about') }}</router-link>
          </el-menu-item>
        </el-menu>

        <div class="search-box">
          <el-input
              v-model="searchKeyword"
              @keyup.enter.native="handleSearch"
              placeholder="请输入产品型号"
          />
          <span class="search-label" @click="handleSearch">{{ t('search') }}</span>
        </div>

        <el-dropdown @command="changeLang" class="lang-dropdown">
          <span class="el-dropdown-link">
            <img :src="currentLang === 'zh' ? flagCn : flagEn" class="flag-icon" />
            {{ currentLang === 'zh' ? '中文' : 'English' }}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh">
              <img :src="flagCn" class="flag-icon" /> 中文
            </el-dropdown-item>
            <el-dropdown-item command="en">
              <img :src="flagEn" class="flag-icon" /> English
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <!-- 移动端菜单按钮 -->
      <div class="mobile-toggle" @click="showMobileMenu = !showMobileMenu">
        <i class="el-icon-menu"></i>
      </div>
    </el-header>

    <!-- ✅ 移动端菜单 -->
    <transition name="fade">
      <div v-if="showMobileMenu" class="mobile-menu">
        <router-link to="/index" class="mobile-link">{{ t('home') }}</router-link>
        <router-link to="/productSearch" class="mobile-link">{{ t('product') }}</router-link>
        <router-link to="/ContactUs" class="mobile-link">{{ t('support') }}</router-link>
        <router-link to="/join" class="mobile-link">{{ t('about') }}</router-link>
        <div class="mobile-search">
          <el-input
              v-model="searchKeyword"
              size="mini"
              placeholder="请输入产品型号"
              @keyup.enter.native="handleSearch"
          />
          <span class="mobile-search-btn" @click="handleSearch">{{ t('search') }}</span>
        </div>
        <div class="mobile-lang" @click="changeLang(currentLang === 'zh' ? 'en' : 'zh')">
          <img :src="currentLang === 'zh' ? flagEn : flagCn" class="flag-icon" />
          {{ currentLang === 'zh' ? 'English' : '中文' }}
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
export default {
  name: 'AppHeader',
  props: ['currentLang', 'flagCn', 'flagEn', 't'],
  data() {
    return {
      searchKeyword: '',
      showMobileMenu: false
    };
  },
  methods: {
    changeLang(lang) {
      this.$emit('change-lang', lang);
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        this.$router.push({
          name: 'ProductSearch',
          query: {
            search: this.searchKeyword,
            _t: Date.now()
          }
        });
      } else {
        this.$message.warning('请输入搜索内容');
      }
    }
  }
};
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  width:100%;

  background-color: #0d0d0d !important;
}

.header-wrapper {
  z-index: 1000;
  top:0;
  position: sticky;
  width: 100%;
  transition: all 0.3s ease;

}

/* 添加滚动时的样式类 */
.header-wrapper.scrolled {
  background-color: rgba(13, 13, 13, 0.9);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.logo {
  font-weight: bold;
  font-size: 20px;
}

.nav-links {
  display: flex;
  align-items: center;
  width: 90%;

}

.search-box {
  display: flex;
  align-items: center;
  margin-left: 30px;
}

.search-label {
  margin-left: 10px;
  color: #fff;
  cursor: pointer;
  width:50px;
}

.lang-dropdown {
  margin-left: 20px;
  color: #fff;
}

.flag-icon {
  width: 20px;
  height: 14px;
  margin-right: 5px;
  vertical-align: middle;
}

.a-style {
  color: inherit;
  text-decoration: none;
  display: block;
}

.no-bottom-line::v-deep .el-menu--horizontal {
  border-bottom: none !important;
}


/* ✅ 移动端折叠菜单按钮 */
.mobile-toggle {
  display: none;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
}

/* ✅ 移动端菜单内容 */
.mobile-menu {
  display: none;
  flex-direction: column;
  background: #0d0d0d;
  padding: 10px 20px;
}

.mobile-link {
  padding: 10px 0;
  color: #fff;
  text-decoration: none;
  border-bottom: 1px solid #333;
}

.mobile-search {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.mobile-search-btn {
  margin-left: 8px;
  color: #fff;
  cursor: pointer;
}

.mobile-lang {
  margin-top: 10px;
  color: #fff;
  cursor: pointer;
}
::v-deep .el-menu.el-menu--horizontal{
  border-bottom: none !important;
}
/* ✅ 响应式适配 */
@media screen and (max-width: 768px) {
  .header-wrapper {
    background-color: #000000;
  }

  .nav-links {
    display: none !important; /* 隐藏原有横向导航 */

  }

  .mobile-toggle {
    display: block;
  }

  .mobile-menu {
    display: flex;
  }
}

@media screen and (min-width: 769px) {
  .mobile-toggle {
    display: none;
  }

  .mobile-menu {
    display: none;
  }
}
.header-wrapper {
  background-color: #000000;
}

</style>
